import Phaser from "phaser";
/**@param {Phaser.Scene} scene*/
export const createStone = (scene, x, y, originX, originY, scale, velocity) => {
  const randomNo = () => {
    return Phaser.Math.Between(0, 18);
  };
  const stone = scene.physics.add
    .image(x, y, `stone${randomNo()}`)
    .setOrigin(originX, originY)
    .setScale(scale)
    .setVelocity(velocity, 0)
    .setImmovable();
  stone.setBodySize(stone.body.width - 50, stone.body.height - 50);
  return stone;
};
